export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-50/80">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-xl text-background-50"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                麻花影院
              </span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-300 mb-4">
              麻花影院免费观看平台，提供海量高清电影、电视剧、综艺在线播放服务。每日更新热播内容，无需付费即可畅享流畅观影体验。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 text-background-50/60 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 text-background-50/60 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 text-background-50/60 hover:text-background-50 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><a href="#media" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">精选内容</a></li>
              <li><a href="#cards" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">热播精选</a></li>
              <li><a href="#ranking" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">热播榜单</a></li>
              <li><a href="#topics" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">热门话题</a></li>
              <li><a href="#index" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">分类索引</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">服务支持</h4>
            <ul className="space-y-2.5">
              <li><a href="#faq" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">常见问答</a></li>
              <li><a href="#contact" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">联系我们</a></li>
              <li><a href="#updates" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">最新更新</a></li>
              <li><a href="#comments" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">用户热评</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              感谢各大影视平台与内容合作伙伴的支持。更多合作信息敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-foreground-800/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} 麻花影院 - 麻花影院免费观看平台。本站内容仅供学习交流，请支持正版。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">用户协议</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}